// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BoostController from "./boost_controller"
application.register("boost", BoostController)

import IntakeController from "./intake_controller"
application.register("intake", IntakeController)

import CreditController from "./credit_controller"
application.register("credit", CreditController)

import PaymentController from "./payment_controller"
application.register("payment", PaymentController)

import DeliveryController from "./delivery_controller"
application.register("delivery", DeliveryController)

import OrderController from "./order_controller"
application.register("order", OrderController)

import RequestController from "./request_controller"
application.register("request", RequestController)

import CardController from "./card_controller"
application.register("card", CardController)

import TaxPrepProviderNewController from "./tax_prep_provider_new_controller"
application.register("tax-prep-provider-new", TaxPrepProviderNewController)

import TaxPrepProfileController from "./tax_prep_profile_controller"
application.register("tax-prep-profile", TaxPrepProfileController)

import TaxPrepProviderInfoController from "./tax_prep_provider_info_controller"
application.register("tax-prep-provider-info", TaxPrepProviderInfoController)

import TaxPrepAdditionalInformationController from "./tax_prep_additional_information_controller"
application.register("tax-prep-additional-information", TaxPrepAdditionalInformationController)

import NoteFormController from "./note_form_controller"
application.register("note-form", NoteFormController)

import LenderBatchEditController from "./lender_batch_edit_controller"
application.register("lender-batch-edit", LenderBatchEditController)

import TableColumnsController from "./table_columns_controller"
application.register("table-columns", TableColumnsController)

import DocUploadController from "./doc_upload_controller"
application.register("doc-upload", DocUploadController)

import CtaTrackingController from "./cta_tracking_controller"
application.register("cta-tracking", CtaTrackingController)

import DocActionsController from "./doc_actions_controller"
application.register("doc-actions", DocActionsController)

import FundingClientStageController from "./funding_client_stage_controller"
application.register("funding-client-stage", FundingClientStageController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import ServiceRecordsViewController from "./service_records_view_controller"
application.register("service-records-view", ServiceRecordsViewController)

import ComplianceDashboardController from "./compliance_dashboard_controller"
application.register("compliance-dashboard", ComplianceDashboardController)

import CreditRepairDashboardController from "./credit_repair_dashboard_controller"
application.register("credit-repair-dashboard", CreditRepairDashboardController)
import ShelfCorpDashboardController from "./shelf_corp_dashboard_controller"
application.register("shelf-corp-dashboard", ShelfCorpDashboardController)

import SocialPostModalController from "./social_post_modal_controller"
application.register("social-post-modal", SocialPostModalController)

import SignaturePadController from "./signature_pad_controller"
application.register("signature-pad", SignaturePadController)

import HotBankSelectController from "./hot_bank_select_controller"
application.register("hot-bank-select", HotBankSelectController)

import HotBankFilterController from "./hot_bank_filter_controller"
application.register("hot-bank-filter", HotBankFilterController)

import LenderPickerController from "./lender_picker_controller"
application.register("lender-picker", LenderPickerController)

import LenderPrefillController from "./lender_prefill_controller"
application.register("lender-prefill", LenderPrefillController)

import LiveStateController from "./live_state_controller"
application.register("live-state", LiveStateController)
